<template>
        <div class="has-text-centered has-text-white scrollableY">
          <div class="container settsPad">
                 <div class="bottom20">&nbsp;</div>
                <H1 class="has-text-white is-size-3"><img src="@/assets/img/fourDotsLogo.png" width="24"/> MANAGE SUBSCRIPTION </H1>
                <div class="wideLimitWidth2 top10 marginAutod has-text-centered">
                    
                    <div v-show="!subcriptionUpdated" class="has-text-left">
                        <div class="top20">To change your current plan select one and click submit.</div>
                        <div class="columns has-text-left top10">
                            <div class="column is-flex">
                                <div class="paidPlans" @click="plan = 'free'; onPlanChange()" :class="{selected: plan == 'free'}">
                                    <div v-show="plan == 'free'" class="currentPlan"><i class="fa fa-check"></i></div>
                                    <div class="planName"><b>{{plans[0].name}}</b></div>
                                    <!-- <div class="planPrice top10">{{plans[0].price}}/{{plans[0].units}}</div> -->
                                    <!-- <button v-show="plan != 'free'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                   
                                    <div class="planPrice top10"><b>Like we said, free!</b></div>
                                        <div class="top10">&bull; {{getPlanBundleLimit('free')}} bundle limit</div>
                                        <div >&bull; {{getPlanCardLimit('free')}} miimu limit</div>
                                        <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20" :class="{buttonDisabled: plan == 'free'}">SELECT</button></div>
                                    </div>
                                    <!-- <div v-show="plan == 'free'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                   
                            </div>
                            <div class="column is-flex">
                                <div class="paidPlans" @click="plan = 'monthly'; onPlanChange()" :class="{selected: plan == 'monthly'}">
                                    <div v-show="plan == 'monthly'" class="currentPlan"><i class="fa fa-check"></i></div>
                                    <div class="planName"><b>{{plans[1].name}}</b></div>
                                    <div class="planPrice top10"><b>${{plans[1].price}}/{{plans[1].units}}</b></div>
                                    <!-- <button v-show="plan != 'monthly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                   
                                    <div class="top10">&bull; Unlimited bundles</div>
                                        <div >&bull; Unlimited miimus</div>
                                        <div >&bull; Collab bundles</div>
                                        <div >&bull; Hide Ads</div>
                                        <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20" :class="{buttonDisabled: plan == 'monthly'}">SELECT</button></div>
                                        <!-- <div v-show="plan == 'monthly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                </div>
                            </div>
    
                            <div class="column is-flex">
                                <div class="paidPlans" @click="plan = 'yearly'; onPlanChange()" :class="{selected: plan == 'yearly'}">
                                    <div v-show="plan == 'yearly'" class="currentPlan"><i class="fa fa-check"></i></div>
                                    <div class="planName"><b>{{plans[2].name}}</b></div>
                                    <div class="planPrice top10"><b>${{plans[2].price}}/{{plans[2].units}}</b></div>
                                    <!--  <button v-show="plan != 'yearly'" class="top20 button is-small is-coolGreen">SELECT</button> -->
                                    <div class="bValue has-text-centered">
                                        <i class="fa fa-certificate is-size-4 has-text-coolGreen"></i>
                                        <div class="is-size-7 txt"><b>Best<br>Value</b></div>
                                        
                                    </div>
                                    <div class="top10">&bull; Unlimited bundles</div>
                                    <div >&bull; Unlimited miimus</div>
                                    <div >&bull; Collab bundles</div>
                                    <div >&bull; Hide Ads</div>
                                    <div class="planButtonDiv has-text-centered"><button class="button is-small is-coolGreen top20" :class="{buttonDisabled: plan == 'yearly'}">SELECT</button></div>
                                    <!--  <div v-show="plan == 'yearly'" class="top20 has-text-coolGreen"><i class="fa fa-check fa-2x"></i></div> -->
                                </div>
                            </div>
                        </div>
    
                        <form class="form has-text-left" v-on:submit.prevent="submit">
                           
                           <!--  <div class="top20">
                                <div class="field" v-for="p in plans" :key="p.code">
                                    <input
                                    class="is-coolGreen"
                                    :id="p.code"
                                    type="radio"
                                    name="plan"
                                    :value="p.code"
                                    v-model="plan"
                                    @change="onPlanChange"
                                    />
                                    <label for="p.code"> {{ p.name }}{{ p.code === 'free' ? '' : ' - $' + p.price + '/' + p.units }}{{ p.recommended ? ' (Best Value)' : ''}}</label>
                                </div>
                            </div> -->
                         
                            <div class="has-text-white top40">
                                Credit card ending in: *<a class="card-update-link" title="Update payment info." @click="updateCard">{{ last4 }}</a>
                            </div>
                            <div class="has-text-white" v-if="pendingPlan">
                                Current "{{ getExistingPlanName() }}" subscription expires on {{ pendingDate.toLocaleDateString() }}.
                            </div>
    
                            <button id="updateSub" class="button is-coolGreen top20" :disabled="submitDisabled" type="submit">SUBMIT</button>
                            <div class="has-text-danger has-text-weight-bold top10" v-show="showErrors == true">Please correct the errors in the form and submit again.</div>
                            <div class="bottom20"></div>
                        </form>
                    </div>
                </div>
    
                <div v-show="subcriptionUpdated">
                    <div class="has-text-white">
                        <div class="is-size-3">Subscription Updated!</div> <br>

                        We hope you enjoy your new plan!<br><br>
    
                        If you have any questions, please contact us.<br><br><br><br>
                    </div>
                </div>
    
                <div v-show="declined">
                    <div class="has-text-white">
                        <div class="is-size-3">Oops! Something went wrong!</div> <br>
                        
                        We were unable to charge your credit card. Please update your payment info <b class="pointerCursor" @click="$router.push('/pmtsrc')">here</b>.  Once you have done so we will attempt the charge again.<br><br>
    
                        Your subscription has been created but is pending payment. We will not ship any products until a valid payment source is provided. Subscription ID: <b>{{subsId}}</b><br><br>
    
                        If you have any questions, please contact us.<br><br><br><br>
                    </div>
                </div>
    
            </div>
          </div>
</template>

<script>

import countries from '../static/countries.js'
import { AZEventBus } from '../components/AZEventBus.js';
let loadStripe;

export default {
    data: function(){
        var planForm = {
            address1: '',
            address2: '',
            city: '',
            state: '',
            zip: '',
            country: '',
            nameOnCard: ''
        }

        return{
            initialized: false,
            countries,

            planForm: planForm,
            plans: null,
            existingPlan: null,
            plan: null,
            pendingPlan: null,
            pendingDate: null,
            existingCardOrNew: 'existing',
            last4: null,

            subcriptionUpdated: false,
            showErrorsLine: false,
            submitDisabled: true,
        }
    },
    filters: {
        countryFromCode: function (value) {
            if (!value) return '';
            value = value.toString();
            for(var i=0; i < countries.length; i++){
                if(value == countries[i].code){
                    return countries[i].name;
                }
            }
            return ''
        }
    },
    components: {

    },
    mounted: async function(){
        const self = this

        if(this.$root.app.doneFederating){
            this.initialize();
        }
        AZEventBus.$once('onFederate', msg => {
            this.initialize();
        });

        // Load plans.  Don't need to wait for federating.
        // TODO might want to combine this with other requests
        // to minimize number of lambda calls.
        this.$root.app.apiClient.get('open/confirm/plans', {}, (plans) => {
            self.plans = plans;
        }, (e) => {
            console.log(e);
        });

        // Initialize Stripe
        if (!this.$root.app.inApp) {
            if (!loadStripe) {
                loadStripe = (await import('@stripe/stripe-js')).loadStripe;
            }
            this.stripe = await loadStripe(process.env.VUE_APP_STRIPE_PUB_KEY);
        }
        
    },
    methods:{
        initialize: function() {
            if (this.initialized) {
                return
            }

            // Load user plan info.
            this.$root.app.apiClient.get('auth/account/subInfo', {}, (res) => {
                this.existingPlan = res.planCode;
                this.plan = res.pendingPlanCode ? res.pendingPlanCode : res.planCode;
                this.pendingPlan = res.pendingPlanCode;
                this.pendingDate = new Date(res.pendingDate);
                this.last4 = res.last4;
            }, (e) => {
                console.log(e);
            });

            this.initialized = true;
        },
        updateCard: function() {
            this.$root.app.goAfterPmtSrc = 'subscription';
            this.$router.push({name: 'accsettings', params: {section: 'pmtSrc', id: Math.random()}});
        },
        submit: function() {
            var self = this
            this.$validator.validateAll().then(async success => {
                if (success) {
                    let existingPrice = this.getExistingPlanPrice();
                    let price = this.getPlanPrice();
                    let pendingPrice = this.getPendingPlanPrice();

                    // No plan subscribing to plan or canceled plan subscribing to same plan.
                    if ((existingPrice === 0 || (pendingPrice === 0 && this.existingPlan === this.plan)) && price > 0) {
                    
                        az.addRemSpinner(true, 'id', 'updateSub');
                        self.$root.app.apiClient.post('open/subscribe', {
                            sub: self.$root.app.userAttrs.sub,
                            planCode: this.plan
                        }, (res) => {

                            // Success
                            let secret = res.secret;
                            this.stripe.confirmCardPayment(res.secret)
                                .then(async result => {
                                    // TODO
                                    az.addRemSpinner(false, 'id', 'updateSub');
                                    if (result.error) {
                                        this.error = result.error.message;
                                        this.submitDisabled = false;
                                        window.scrollTo({top:0, behavior:'smooth'});
                                    } else {
                                        self.subcriptionUpdated = true;
                                        self.$root.app.userAttrs.hasUpgraded = true;
                                        self.$root.app.userAttrs.bundleLimit = this.getPlanBundleLimit();
                                        self.$root.app.userAttrs.cardLimit = this.getPlanCardLimit();
                                    }
                                });

                        }, (e) => {

                            // Failure
                            console.log(e);

                        });

                    } else if ((existingPrice > 0 && price > existingPrice) || (pendingPrice > 0 && this.existingPlan === this.plan)) {

                        az.addRemSpinner(true, 'id', 'updateSub');
                        self.$root.app.apiClient.post('auth/account/upgrade', {
                            planCode: this.plan
                        }, (res) => {

                            // Success
                            let secret = res.secret;
                            this.stripe.confirmCardPayment(res.secret)
                                .then(async result => {
                                    // TODO
                                    az.addRemSpinner(false, 'id', 'updateSub');
                                    if (result.error) {
                                        this.error = result.error.message;
                                        this.submitDisabled = false;
                                        window.scrollTo({top:0, behavior:'smooth'});
                                    } else {
                                        self.subcriptionUpdated = true;
                                        //self.$root.app.userAttrs.hasUpgraded = true;
                                        self.$root.app.userAttrs.bundleLimit = this.getPlanBundleLimit();
                                        self.$root.app.userAttrs.cardLimit = this.getPlanCardLimit();
                                    }
                                });

                        }, (e) => {
                        });
                    } else if (price > 0 && price <= existingPrice) {

                        az.addRemSpinner(true, 'id', 'updateSub');
                        self.$root.app.apiClient.post('auth/account/downgrade', {
                            planCode: this.plan
                        }, (res) => {
                            az.addRemSpinner(false, 'id', 'updateSub');
                            self.subcriptionUpdated = true;
                            //self.$root.app.userAttrs.hasUpgraded = true;
                            self.$root.app.userAttrs.bundleLimit = this.getPlanBundleLimit();
                            self.$root.app.userAttrs.cardLimit = this.getPlanCardLimit();

                        }, (e) => {
                        });
                    } else if (price === 0 && existingPrice > 0) {

                        az.addRemSpinner(true, 'id', 'updateSub');
                        self.$root.app.apiClient.post('auth/account/cancel', {}, (res) => {
                            az.addRemSpinner(false, 'id', 'updateSub');
                            self.subcriptionUpdated = true;
                            //self.$root.app.userAttrs.hasUpgraded = true;
                            self.$root.app.userAttrs.bundleLimit = this.getPlanBundleLimit();
                            self.$root.app.userAttrs.cardLimit = this.getPlanCardLimit();
                        }, (e) => {
                        });
                    } else {
                        // Make it look like it did something.
                        setTimeout(() => {
                            self.showPlans = false;
                            self.showThankYou = true;
                        }, 1000);
                    }

                } else {
                    // This should never happen.
                    self.showErrorsLine = true;
                }
            })
            
        },
        onPlanChange() {
            if ((this.pendingPlan && this.plan == this.pendingPlan) || (!this.pendingPlan && this.plan === this.existingPlan)) {
                this.submitDisabled = true;
            } else {
                this.submitDisabled = false;
            }
        },
        getExistingPlanName() {
            let name = null;
            for (let p of this.plans) {
                if (p.code == this.existingPlan) {
                    name = p.name;
                    break;
                }
            }

            return name;
        },
        getExistingPlanPrice() {
            let price = null;
            for (let p of this.plans) {
                if (p.code == this.existingPlan) {
                    price = p.price;
                    break;
                }
            }

            return parseFloat(price);
        },
        getPlanPrice() {
            let price = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        price = p.price;
                        break;
                    }
                }
            }

            return price != null ? parseFloat(price) : '';
        },
        getPendingPlanPrice() {
            let price = null;
            if (this.pendingPlan) {
                for (let p of this.plans) {
                    if (p.code == this.pendingPlan) {
                        price = p.price;
                        break;
                    }
                }
            }

            return price ? parseFloat(price) : null;
        },
        getPlanUnits() {
            let units = null;

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == this.plan) {
                        units = p.units;
                        break;
                    }
                }
            }

            return units != null ? units : 'month';
        },
        getPlanBundleLimit(plan) {
            let bundleLimit = null;

            if (!plan) {
                plan = this.plan;
            }

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == plan) {
                        bundleLimit = p.bundleLimit;
                        break;
                    }
                }
            }

            return bundleLimit != null ? bundleLimit : 20;
        },
        getPlanCardLimit(plan) {
            let cardLimit = null;

            if (!plan) {
                plan = this.plan;
            }

            if (this.plans != null) {
                for (let p of this.plans) {
                    if (p.code == plan) {
                        cardLimit = p.cardLimit;
                        break;
                    }
                }
            }

            return cardLimit != null ? cardLimit : 200;
        },
        hasUpgraded() {
            return this.$root.app.userAttrs.hasUpgraded === true;
        },
    }
}
</script>
